const WeSpinGameRoomBuyInButton = ({ amount, updateBuyInAmountCallback, formattedAmount, globalAmount, enabled }) => {
	let className = 'btn btn--small';
	className = Number.parseInt(globalAmount, 10) === amount ? className : `${className} btn--light`;
	return (
		<button
			value={amount}
			onClick={updateBuyInAmountCallback}
			key={amount}
			className={className}
			disabled={!enabled}
		>
			{formattedAmount}
		</button>
	);
};

export default WeSpinGameRoomBuyInButton;
